import { RecommendationMatching } from '../components/RecommendationMatching';

export default function MatchingPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">Professional Matching</h1>
          <p className="text-muted-foreground mt-1">
            Connect with investors, analysts, and advisors based on your needs
          </p>
        </div>
      </div>
      <RecommendationMatching />
    </div>
  );
}
